/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-restricted-globals */
import React, { useCallback, useEffect, useState } from 'react';
import { Bookmark, Pencil, Trash } from '@saleshandy/icons';
import { useHistory, useLocation } from 'react-router-dom';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import {
  OverlayPopover,
  Placement,
} from '../../../../../shared/design-system/components/overlay';
import SaveFilterModal from '../../modal/save-filter-modal';
import { getSavedFilterListAPI } from '../../../helpers/leads.api';
import {
  collapseHierarchicalChildrenToParentKeys,
  encodeLocationV2Entry,
  locationItemToSuggestion,
} from '../../../helpers/helper';
import { INDUSTRY_DATA } from '../../../helpers/filter-data';
import { SaveFilterModalVarient } from '../../modal/save-filter-modal/types';
import Transfer from '../../../../../shared/design-system/components/transfer/transfer';
import Button from '../../../../../shared/design-system/components/atoms/button';
import { leadFinderViewOnly } from '../../../../../shared/utils/user-details';
import toaster from '../../../../../shared/toaster';
import { RootState } from '../../../../../store/root-reducer';
import {
  LeadFinderPrimaryTab,
  LeadFinderSecondaryTab,
  SavedFilterTab,
} from '../../../types';
import Icon from '../../../../../shared/design-system/components/atoms/icon';

export default function SavedFilter({
  handleGeneratePayload,
  isLoading,
  applyPendingFilters,
  hasPendingFilters,
  isPartialFilterApplied = false,
  isLimitFilterInvalid = false,
  applyExternalBulkFilters = undefined,
  skipUrlPushForBulkSearch = false,
}) {
  const history = useHistory();
  const location = useLocation();
  const [savedFilters, setSavedFilters] = useState<any>([]);
  const activeLeadType = useSelector(
    (state: RootState) => state.leadFinderV2.activeLeadType,
  );
  const isBulkModeActive = useSelector(
    (state: RootState) => state.leadFinderV2.bulkPeopleSearch.isBulkModeActive,
  );
  const savedFilterTab =
    activeLeadType === LeadFinderPrimaryTab.COMPANY
      ? SavedFilterTab.COMPANIES
      : SavedFilterTab.PEOPLE;

  const [selectedSavedFilter, setSelectedSavedFilter] = useState<any>();
  const [showPopOver, setshowPopOver] = useState<boolean>(false);
  const [showSaveFilter, setshowSaveFilter] = useState<boolean>(false);
  const [showEditFilter, setshowEditFilter] = useState<boolean>(false);
  const [showDeleteFilter, setshowDeleteFilter] = useState<boolean>(false);
  const [showAppliedFilter, setshowAppliedFilter] = useState<boolean>(false);
  const isLeadFinderViewOnly = leadFinderViewOnly();

  const [activeFilter, setActiveFilter] = useState(null);

  const onToggle = () => {
    setshowPopOver(!showPopOver);
  };
  const onToggleAppliedFilter = () => {
    setshowAppliedFilter(!showAppliedFilter);
  };
  const hideSaveFilterModal = () => {
    setshowSaveFilter(false);
  };
  const hideEditSaveFilterModal = () => {
    setshowEditFilter(false);
  };
  const hideDeleteSavedFilterModal = () => {
    setshowDeleteFilter(false);
  };

  const getSavedFilters = async () => {
    try {
      const res = await getSavedFilterListAPI(savedFilterTab);
      if (res) {
        const mappedArray = res.payload.map((item) => ({
          ...item,
          // eslint-disable-next-line no-underscore-dangle
          key: item?._id,
        }));
        setSavedFilters(mappedArray);
      }
    } catch (e: any) {
      if (!e?.isHandled) {
        toaster.error(
          e.message || "Couldn't fetch saved filters. Please try again.",
        );
      }
    }
  };
  const SAVED_FILTER_KEY_MAP: Record<string, string> = {
    signalIds: 'signals',
    newsIds: 'news',
    companyList: 'company_list',
    look_alike_website_domain: 'website_domain',
    peopleList: 'people_list',
    limitPerCompany: 'limit',
  };

  const resolveSavedFilterUrlKey = (savedKey: string): string => {
    if (
      savedKey === 'company_funding_date' &&
      savedFilterTab === SavedFilterTab.COMPANIES
    ) {
      return 'funding_rounds_announced_date';
    }
    return SAVED_FILTER_KEY_MAP[savedKey] ?? savedKey;
  };

  const DATE_FIELD_KEYS = new Set([
    'company_funding_date',
    'funding_rounds_announced_date',
    'last_funding_round_announced_date',
  ]);

  const HIERARCHICAL_COLLAPSE_FILTER_KEYS: Record<string, any[]> = {
    company_industry: INDUSTRY_DATA,
  };

  const toUrlHierarchicalFilterItems = (
    filterKey: string,
    items: string[],
  ): string[] => {
    const hierarchicalData = HIERARCHICAL_COLLAPSE_FILTER_KEYS[filterKey];
    if (!hierarchicalData?.length || !items?.length) return items;
    return collapseHierarchicalChildrenToParentKeys(items, hierarchicalData);
  };

  const PEOPLE_BULK_FILTER_KEYS = new Set([
    'linkedin_url',
    'company_name',
    'company_domain',
    'keywords',
  ]);

  const COMPANY_BULK_FILTER_KEYS = new Set([
    'company_name',
    'company_domain',
    'linkedin_url',
  ]);

  const buildFilterParams = (filterObject: any): URLSearchParams => {
    const queryParts: string[] = [];

    // Helper to add a query param
    const addParam = (paramKey: string, paramValue: string) => {
      if (
        paramValue !== undefined &&
        paramValue !== null &&
        paramValue !== ''
      ) {
        const encoded = encodeURIComponent(paramValue).replace(/%20/g, '+');
        queryParts.push(`${paramKey}=${encoded}`);
      }
    };

    // Helper to format min/max as a URL range string
    const formatMinMax = (min: string, max: string): string | null => {
      if (min && max) return `${min}-${max}`;
      if (min && !max) return `${min}+`;
      if (!min && max) return `<${max}`;
      return null;
    };

    // Helper to get the exclude key for a filter
    const getExcludeKey = (filterKey: string): string =>
      `exclude${filterKey.charAt(0).toUpperCase()}${filterKey.slice(1)}`;

    Object.entries(filterObject).forEach(([key, value]: [string, any]) => {
      if (value === null || value === undefined) {
        return;
      }

      const urlKey = resolveSavedFilterUrlKey(key);

      if (typeof value === 'boolean') {
        addParam(urlKey, value ? '1' : '0');
        return;
      }

      // Handle simple primitive values (like decision_maker: 1, is_b2b: 0)
      if (typeof value === 'number' || typeof value === 'string') {
        addParam(urlKey, String(value));
        return;
      }

      if (key === 'look_alike_company_name' && Array.isArray(value)) {
        value.forEach((item: any) => {
          addParam('competitors_company_name', item.value);
          addParam('competitors_company_id', String(item.company_id ?? 0));
        });
        return;
      }

      // Handle date range fields — require " - " separator (space-dash-space) for getDateRange() parsing
      if (
        DATE_FIELD_KEYS.has(urlKey) &&
        typeof value === 'object' &&
        !Array.isArray(value)
      ) {
        if (value.allTime === 1 || value.exists === true) {
          addParam(urlKey, 'all time');
        } else if (value.min || value.max) {
          const min = value.min ?? '';
          const max = value.max ?? '';
          if (min && max) addParam(urlKey, `${min} - ${max}`);
          else if (min) addParam(urlKey, min);
          else if (max) addParam(urlKey, max);
        }
        return;
      }

      // Handle visits_breakdown_by_country → indexed params
      if (urlKey === 'visits_breakdown_by_country' && Array.isArray(value)) {
        value.forEach((item: any, index: number) => {
          addParam(`visits_breakdown_by_country_${index}`, item.country);
          const result = formatMinMax(
            item.percentage?.min ?? '',
            item.percentage?.max ?? '',
          );
          if (result) {
            addParam(`visits_breakdown_by_country_percentage_${index}`, result);
          }
        });
        return;
      }

      // Handle visits_breakdown_by_gender → type + range params
      if (urlKey === 'visits_breakdown_by_gender' && Array.isArray(value)) {
        const first = value[0];
        if (first) {
          addParam('visits_breakdown_by_gender_type', first.gender);
          const result = formatMinMax(
            first.percentage?.min ?? '',
            first.percentage?.max ?? '',
          );
          if (result) addParam('visits_breakdown_by_gender_range', result);
        }
        return;
      }

      // Handle base_salary → indexed title + percentage params
      if (urlKey === 'base_salary' && Array.isArray(value)) {
        value.forEach((item: any, index: number) => {
          const titleValue = item?.title?.includes?.[0];
          if (titleValue) addParam(`base_salary_title_${index}`, titleValue);
          const result = formatMinMax(
            item.range?.min ?? '',
            item.range?.max ?? '',
          );
          if (result) addParam(`base_salary_title_percentage_${index}`, result);
        });
        return;
      }

      // Handle employee_count_seniority → per-group paramKey
      if (urlKey === 'employee_count_seniority' && Array.isArray(value)) {
        value.forEach((item: any) => {
          const result = formatMinMax(
            item.count?.min ?? '',
            item.count?.max ?? '',
          );
          if (result) addParam(item.group, result);
        });
        return;
      }

      // Handle employee_count_department → per-group paramKey
      if (urlKey === 'employee_count_department' && Array.isArray(value)) {
        value.forEach((item: any) => {
          const result = formatMinMax(
            item.count?.min ?? '',
            item.count?.max ?? '',
          );
          if (result) addParam(item.group, result);
        });
        return;
      }

      // Handle product_reviews_score_change → split into 3 params
      if (
        urlKey === 'product_reviews_score_change' &&
        typeof value === 'object' &&
        !Array.isArray(value)
      ) {
        if (value.duration) {
          addParam('product_reviews_score_change_duration', value.duration);
        }
        if (value.direction) {
          addParam('product_reviews_score_change_direction', value.direction);
        }
        const result = formatMinMax(
          value.points_range?.min ?? '',
          value.points_range?.max ?? '',
        );
        if (result) {
          addParam('product_reviews_score_change_points_range', result);
        }
        return;
      }

      // Handle location_v2 / company_hq_location_v2 — items are LocationV2Item
      // objects that must be re-encoded as "Type:value" strings
      if (
        (urlKey === 'location_v2' || urlKey === 'company_hq_location_v2') &&
        typeof value === 'object' &&
        !Array.isArray(value)
      ) {
        const excludeKey = getExcludeKey(urlKey);

        if (Array.isArray(value.includes)) {
          value.includes.forEach((item: any) => {
            const suggestion = locationItemToSuggestion(item);
            if (suggestion) {
              addParam(
                urlKey,
                encodeLocationV2Entry(suggestion.type, suggestion.value),
              );
            }
          });
        }

        if (Array.isArray(value.excludes)) {
          value.excludes.forEach((item: any) => {
            const suggestion = locationItemToSuggestion(item);
            if (suggestion) {
              addParam(
                excludeKey,
                encodeLocationV2Entry(suggestion.type, suggestion.value),
              );
            }
          });
        }

        if (value.exactMatch === 1 || value.exactMatch === true) {
          addParam(`${urlKey}_exactMatch`, '1');
        }
        if (value.isUnknown !== undefined) {
          addParam(`${urlKey}_isUnknown`, String(value.isUnknown));
        }
        return;
      }

      // Handle objects with includes/excludes structure
      if (typeof value === 'object' && !Array.isArray(value)) {
        // Handle isUnknown-only case (when isUnknown is 1, no filter values)
        if (value.isUnknown === 1 && !value.includes && !value.min) {
          addParam(`${urlKey}_isUnknown`, '1');
          return;
        }

        // Handle includes array
        if (value.includes && Array.isArray(value.includes)) {
          toUrlHierarchicalFilterItems(key, value.includes).forEach(
            (item: string) => {
              addParam(urlKey, item);
            },
          );
        }

        // Handle excludes array
        if (value.excludes && Array.isArray(value.excludes)) {
          const excludeKey = getExcludeKey(urlKey);
          toUrlHierarchicalFilterItems(key, value.excludes).forEach(
            (item: string) => {
              addParam(excludeKey, item);
            },
          );
        }

        // Handle min/max range (for dropdowns like company_size, total_experience, etc.)
        if (value.min !== undefined || value.max !== undefined) {
          const min = value.min ?? '';
          const max = value.max ?? '';
          // Format: "min-max" or "min+" or "<max"
          if (min && max) {
            addParam(urlKey, `${min}-${max}`);
          } else if (min && !max) {
            addParam(urlKey, `${min}+`);
          } else if (!min && max) {
            addParam(urlKey, `<${max}`);
          }
        }

        // Handle exists flag (for company_funding_date with "all time")
        if (value.exists === true) {
          addParam(urlKey, 'all time');
        }

        // Handle exactMatch flag
        if (value.exactMatch === 1 || value.exactMatch === true) {
          addParam(`${urlKey}_exactMatch`, '1');
        }

        // Handle shouldSearchPast flag
        if (value.shouldSearchPast === 1 || value.shouldSearchPast === true) {
          addParam(`${urlKey}_shouldSearchPast`, '1');
        }

        // Handle isUnknown flag (when there are also filter values)
        if (value.isUnknown !== undefined) {
          addParam(`${urlKey}_isUnknown`, String(value.isUnknown));
        }

        return;
      }

      // Handle simple arrays (fallback for any array values)
      if (Array.isArray(value)) {
        value.forEach((item: string) => {
          addParam(urlKey, String(item));
        });
      }
    });

    return new URLSearchParams(queryParts.join('&'));
  };

  const buildQueryString = (filterObject: any, historyObj: any) => {
    const params = buildFilterParams(filterObject);
    // Get current lead type and subtab from URL
    const currentPath = historyObj.location.pathname;
    const pathParts = currentPath.split('/');
    const leadType = pathParts[3] || LeadFinderPrimaryTab.PEOPLE; // Default to people
    const subtab = pathParts[4] || LeadFinderSecondaryTab.TOTAL; // Default to total
    const finalUrl = `/v2/leads/${leadType}/${subtab}?${params.toString()}`;

    // Push to route
    historyObj.push(finalUrl);
    // Don't call searchLeads() directly - let the useEffect watching location.search handle it
    // This prevents duplicate API calls
    setshowPopOver(false);
  };

  const applySavedFilter = (option: any) => {
    const searchQuery = option?.searchQuery;

    const shouldApplyWithoutUrl =
      (skipUrlPushForBulkSearch || isBulkModeActive) &&
      !!applyExternalBulkFilters;

    if (shouldApplyWithoutUrl) {
      const params = buildFilterParams(searchQuery);
      applyExternalBulkFilters(params);
      setshowPopOver(false);
      return;
    }

    if (
      activeLeadType === LeadFinderPrimaryTab.PEOPLE &&
      applyExternalBulkFilters &&
      Object.keys(searchQuery || {}).some((k) => PEOPLE_BULK_FILTER_KEYS.has(k))
    ) {
      const params = buildFilterParams(searchQuery);
      applyExternalBulkFilters(params);
      setshowPopOver(false);
      return;
    }

    if (
      activeLeadType === LeadFinderPrimaryTab.COMPANY &&
      applyExternalBulkFilters &&
      Object.keys(searchQuery || {}).some((k) =>
        COMPANY_BULK_FILTER_KEYS.has(k),
      )
    ) {
      const params = buildFilterParams(searchQuery);
      applyExternalBulkFilters(params);
      setshowPopOver(false);
      return;
    }

    buildQueryString(searchQuery, history);
  };

  useEffect(() => {
    if (!isLeadFinderViewOnly) {
      getSavedFilters();
    }
  }, [isLeadFinderViewOnly]);

  useEffect(() => {
    if (savedFilters && savedFilters?.length > 0) {
      const payload = handleGeneratePayload();
      // eslint-disable-next-line no-restricted-syntax
      for (const f of savedFilters) {
        if (_.isEqual(f?.searchQuery, payload)) {
          setActiveFilter(f);
        }
      }
    }
    return () => {
      setActiveFilter(null);
    };
  }, [location?.search, savedFilters]);

  const searchLead = useCallback(() => {
    if (applyPendingFilters) {
      applyPendingFilters();
    }
  }, [applyPendingFilters]);

  const hasPendingApplied =
    typeof hasPendingFilters === 'function' && hasPendingFilters();

  const hasFiltersToSave =
    !!location?.search ||
    (isBulkModeActive && hasPendingApplied) ||
    (skipUrlPushForBulkSearch && hasPendingApplied);

  return (
    <div
      className={`v2-saved-filters-container ${
        isLeadFinderViewOnly ? 'v2-saved-filter-container-custom' : ''
      }`}
    >
      <div className="v2-saved-filters-button">
        <Button
          onClick={() => searchLead()}
          variant={Button.Variant.Primary}
          iconLeft={<Icon identifier="search" className="search-icon" />}
          disabled={
            (!hasPendingFilters ? !location?.search : !hasPendingFilters()) ||
            isLoading ||
            isPartialFilterApplied ||
            isLimitFilterInvalid
          }
        >
          <span className="search-txt">Search</span>
        </Button>
      </div>
      {!isLeadFinderViewOnly && (
        <div className="v2-saved-filters-details">
          <div className="v2-saved-filters">
            <OverlayPopover
              show={showPopOver}
              onToggle={onToggle}
              rootClose={true}
              className="prospect-tag-popover"
              content={
                <>
                  <Transfer
                    options={savedFilters}
                    filterOption={(value, option) =>
                      option?.name?.toLowerCase().includes(value.toLowerCase())
                    }
                    optionRenderer={(option: any) => (
                      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                      <div
                        className="d-flex align-items-center"
                        onClick={() => {
                          setSelectedSavedFilter(option);
                          applySavedFilter(option);
                        }}
                      >
                        <p className="v2-search-seved-filter">{option.name}</p>
                        <div className="d-flex">
                          <Pencil
                            className="edit-icon"
                            onClick={(e) => {
                              setshowEditFilter(true);
                              onToggle();
                              e?.stopPropagation();
                              setSelectedSavedFilter(option);
                            }}
                          />
                          <Trash
                            onClick={(e) => {
                              setshowDeleteFilter(true);
                              onToggle();
                              e?.stopPropagation();
                              setSelectedSavedFilter(option);
                            }}
                          />
                        </div>
                      </div>
                    )}
                    showSearch
                    searchPlaceholder="Search"
                  />
                </>
              }
              placement={Placement.TopStart}
            >
              <div className="d-flex align-items-center">
                <div className="icon">
                  <Bookmark />
                </div>
                {/* eslint-disable-next-line */}
                <span onClick={() => setshowPopOver(true)}>Saved Filters</span>
              </div>
            </OverlayPopover>
            <OverlayPopover
              show={showAppliedFilter}
              onToggle={onToggleAppliedFilter}
              className="prospect-tag-applied"
              content={
                <div>
                  <p className="v2-saved-applied-filter">
                    Saved Filter Applied
                  </p>
                  <p className="applied-filter-active">{activeFilter?.name}</p>
                </div>
              }
              placement={Placement.TopStart}
              rootClose={true}
            >
              <div className="d-flex align-items-center">
                {activeFilter && (
                  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                  <div
                    onClick={() => setshowAppliedFilter(true)}
                    className="v2-saved-filter-dot d-block"
                  />
                )}
              </div>
            </OverlayPopover>
          </div>

          <div className="v2-save-filter">
            {/* eslint-disable-next-line */}
            <span
              onClick={() => {
                const canSaveFilter = hasFiltersToSave && !activeFilter;
                if (canSaveFilter) {
                  setshowSaveFilter(true);
                }
              }}
              className={`v2-save-filter-txt ${
                !hasFiltersToSave || activeFilter
                  ? 'v2-disable-save-filter'
                  : ''
              }`}
            >
              Save Filter
            </span>
          </div>

          {showSaveFilter && (
            <SaveFilterModal
              show={showSaveFilter}
              varient={SaveFilterModalVarient.Save}
              onHide={hideSaveFilterModal}
              isLoading={true}
              getSavedFilters={getSavedFilters}
              handleGeneratePayload={handleGeneratePayload}
              savedFilters={savedFilters}
            />
          )}
          {showEditFilter && (
            <SaveFilterModal
              show={showEditFilter}
              varient={SaveFilterModalVarient.Edit}
              onHide={hideEditSaveFilterModal}
              isLoading={true}
              selectedSavedFilter={selectedSavedFilter}
              getSavedFilters={getSavedFilters}
              savedFilters={savedFilters}
            />
          )}
          {showDeleteFilter && (
            <SaveFilterModal
              show={showDeleteFilter}
              varient={SaveFilterModalVarient.Delete}
              onHide={hideDeleteSavedFilterModal}
              isLoading={true}
              selectedSavedFilter={selectedSavedFilter}
              getSavedFilters={getSavedFilters}
            />
          )}
        </div>
      )}
    </div>
  );
}
